module.exports = __webpack_public_path__ + "img/card-icon.b858865f.svg";